// extracted by mini-css-extract-plugin
export default {"pagination":"JWgOnIdyijJmIGiUiLEI","active":"S0d5o62cjzOa5fhnnGnY"};